<div class="tittel" [matTooltip]="mappe().navn">
  <mat-icon class="mappeikon">folder</mat-icon>
  <span class="navn" data-testid="mappe-navn">{{ mappe().navn }}</span>
  @if(redigeringMulig()){
    <span class="meny">
    <button mat-icon-button [matMenuTriggerFor]="meny.matMeny()" (click)="$event.stopPropagation()" class="mat-medium-icon-button meny">
      <mat-icon class="material-symbols-fet">more_vert</mat-icon>
    </button>
    <arkivmappe-meny [mappe]="mappe()" #meny/>
    </span>
  }
</div>
<div class="beskrivelse">
  <html-formatert [innhold]="mappe().beskrivelse" trunker="2"/>
</div>
@if(mappe().skjerming.skjermedeMedlemmerId.length > 0){
  <mat-icon class="skjermet" (click)="visSkjerming()" matTooltip="{{'Mappen er skjult for {antall} medlemmer'| translate: {antall: mappe().skjerming.skjermedeMedlemmerId.length} }}">visibility_lock</mat-icon>
}
